import { render } from "./WhyBank.vue?vue&type=template&id=2525176f&scoped=true&ts=true"
import script from "./WhyBank.vue?vue&type=script&lang=ts"
export * from "./WhyBank.vue?vue&type=script&lang=ts"

import "./WhyBank.vue?vue&type=style&index=0&id=2525176f&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2525176f"]])

export default __exports__